module.exports = __webpack_public_path__ + "static/slicecat-d67d2b09f181ea5b646938e89daec87c.svg";